module.exports = __webpack_public_path__ + "static/arrow-partner-6fc1db9fac8d01888fc1cfe08583f13e.png";